export const loadNotifications =
  (managerId) =>
  async (dispatch, getState, { api }) => {
    let response = await api.get(
      `/notifications${(managerId && "?manager_id=" + managerId) || ""}`,
    );

    dispatch({
      type: "NOTIFICATIONS_SET",
      notifications: response.data,
    });
    return;
  };
